import {useContext} from "react";
import {GlobalModalContext} from "../context/GlobalModalsContext";

const useGlobalModal = () => {
    return useContext(GlobalModalContext);
}

export default useGlobalModal;